import ConfirmDialog from '../../components/common/ConfirmDialog';
import {
  PASSWORD_RESET_CANCEL,
  PASSWORD_RESET_CONFIRM,
  PASSWORD_RESET_SENDING,
  PASSWORD_RESET_TITLE,
  passwordResetBody,
} from './wizard/copy';

interface PasswordResetDialogProps {
  email: string;
  isPending: boolean;
  errorMessage: string | null;
  onConfirm: () => void | Promise<void>;
  onCancel: () => void;
}

/**
 * The confirmation an admin has to clear before a reset mail goes out (OM-4023 AC3). Centered
 * appearance per the Figma, and with no icon — the design carries none, and the shared dialog
 * falls back to its warning glyph unless one is passed explicitly.
 */
export default function PasswordResetDialog({
  email, isPending, errorMessage, onConfirm, onCancel,
}: Readonly<PasswordResetDialogProps>) {
  return (
    <ConfirmDialog
      open
      appearance="centered"
      icon={<></>}
      title={PASSWORD_RESET_TITLE}
      message={passwordResetBody(email)}
      confirmLabel={isPending ? PASSWORD_RESET_SENDING : PASSWORD_RESET_CONFIRM}
      cancelLabel={PASSWORD_RESET_CANCEL}
      isPending={isPending}
      errorMessage={errorMessage}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
}
